export default "__VITE_ASSET__A5Oulp9S__"